import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSiteSettings } from '../services/api';

const RecaptchaContext = createContext();

export const RecaptchaProvider = ({ children }) => {
  const [isReady, setIsReady] = useState(false);
  const [siteKey, setSiteKey] = useState('');
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    loadRecaptcha();
  }, []);

  const loadRecaptcha = async () => {
    try {
      const settings = await getSiteSettings();
      
      if (settings.recaptcha_enabled && settings.recaptcha_site_key) {
        setSiteKey(settings.recaptcha_site_key);
        setEnabled(true);

        // Load reCAPTCHA script
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${settings.recaptcha_site_key}`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          setIsReady(true);
          console.log('✅ reCAPTCHA v3 loaded');
        };
        document.head.appendChild(script);
      } else {
        console.log('ℹ️ reCAPTCHA not enabled');
        setIsReady(true); // Still mark as ready so app doesn't hang
      }
    } catch (error) {
      console.error('Failed to load reCAPTCHA settings:', error);
      setIsReady(true); // Don't block app on error
    }
  };

  const executeRecaptcha = async (action = 'submit') => {
    if (!enabled || !isReady || !window.grecaptcha) {
      return null; // Return null if not enabled/ready
    }

    try {
      const token = await window.grecaptcha.execute(siteKey, { action });
      return token;
    } catch (error) {
      console.error('reCAPTCHA execution error:', error);
      return null;
    }
  };

  return (
    <RecaptchaContext.Provider value={{ isReady, enabled, executeRecaptcha }}>
      {children}
    </RecaptchaContext.Provider>
  );
};

export const useRecaptcha = () => {
  const context = useContext(RecaptchaContext);
  if (!context) {
    throw new Error('useRecaptcha must be used within RecaptchaProvider');
  }
  return context;
};
